import { z } from 'zod/v4';

export const JournalEntityTypeRuntype = z.union([
    z.literal('pcb'),
    z.literal('assembly'),
    z.literal('specification'),
    z.literal('stackup'),
]);

export const PCBJournalEventDescriptorRuntype = z.object({
    entityType: JournalEntityTypeRuntype,
    entityId: z.string(),
    sequenceNr: z.number(),
    ordering: z.number(),
    timestamp: z.string().optional(),
    manifest: z.string(),
    eventType: z.string(),
});

export const PCBJournalTimelineRuntype = z.object({
    pcb: z.string(),
    events: z.array(PCBJournalEventDescriptorRuntype),
    total: z.number(),
    truncated: z.boolean(),
});

export const PCBJournalEventEnvelopeRuntype = z.object({
    entityType: JournalEntityTypeRuntype,
    entityId: z.string(),
    sequenceNr: z.number(),
    ordering: z.number(),
    timestamp: z.string().optional(),
    manifest: z.string(),
    eventType: z.string(),
    payload: z.unknown(),
    payloadError: z.string().optional(),
});

export type PCBJournalTimeline = z.infer<typeof PCBJournalTimelineRuntype>;
export type PCBJournalEventEnvelope = z.infer<typeof PCBJournalEventEnvelopeRuntype>;
